import * as React from 'react';
import { AppUser } from 'Src/views/App/App';
import { Loader } from 'Src/components/Loader/Loader';
import { getStudentCurrentTeams, StudentTeamsOverview } from 'Src/helpers/service/student/teams';
import { StudentPageHeader } from '../components/StudentPageHeader';
import './StudentTeams.scss';
import { TeamMembershipCard } from './TeamMembershipCard';

interface Props {
  user: AppUser;
}

export const StudentTeams = ({ user }: Props) => {
  const [overview, setOverview] = React.useState<StudentTeamsOverview | null>(null);
  React.useEffect(() => {
    let mounted = true;
    getStudentCurrentTeams(user)
      .then(data => mounted && setOverview(data))
      .catch(() => mounted && setOverview({ total: 0, season: '', teams: [] }));
    return () => {
      mounted = false;
    };
  }, [user.roleSessionKey, user.activeSchoolId]);

  if (!overview) return <Loader />;
  return (
    <main className="parentPage studentHubPage studentTeamsPage">
      <StudentPageHeader
        title="My teams"
        subtitle="Teams you belong to in the current academic year."
        chips={[
          { value: overview.total, label: overview.total === 1 ? 'team' : 'teams', tone: 'blue' },
          { label: overview.season, tone: 'slate' }
        ]}
      />
      <section className="studentTeamsGrid">
        {overview.teams.map(team => (
          <TeamMembershipCard team={team} viewerUserId={(user as any).id || (user as any)._id} ageGroupsNaming={(user as any).activeSchool?.ageGroupsNaming} key={team.id} />
        ))}
        {!overview.total && (
          <div className="studentTeamsEmpty">
            <h2>No current teams</h2>
            <p>You are not currently included in a school team roster.</p>
          </div>
        )}
      </section>
    </main>
  );
};
